import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

import { renderLegends } from '../../../../support/SingleLeyendLabel';
import ComplementoSummaryActionButtons from '../components/ComplementoSummaryActionButtons';

const ComplementoInteresesResumen = ({ data = [], onEdit, onDelete, onListChange }) => {

  const handleOnDelete = () => {
    onDelete('Intereses');
  }

  const handleOnEdit = () => {
    onEdit('Intereses', data);
  }

  const options = {
    addSemicolon: true,
    width: 400,
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Intereses, Versión { data.Version }</Card.Subtitle>

        <Row className="mt-3 mb-4">
          <Col sm md="6" className="mb-2">
            { leftLabels.map(renderLegends(data, options)) }
          </Col>

          <Col sm md="6" className="mb-2">
          { rightLabels.map(renderLegends(data, options)) }
          </Col>
        </Row>

        <ComplementoSummaryActionButtons onEdit={ handleOnEdit} onDelete={ handleOnDelete } />
      </Card.Body>
    </Card>
  )
}

const leftLabels = [
  {
    label: 'Sistema financiero',
    index: 'SistFinanciero'
  },
  {
    label: 'Intereses retirados',
    index: 'RetiroAORESRetInt'
  },
  {
    label: 'Operaciones financieras derivados',
    index: 'OperFinancDerivad'
  },
];

const rightLabels = [
  {
    label: 'Importe del interés nominal',
    index: 'MontIntNominal'
  },
  {
    label: 'Monto intereses real',
    index: 'MontIntReal'
  },
  {
    label: 'Pérdida',
    index: 'Perdida'
  },
];

export default ComplementoInteresesResumen
